export const formatJobSalary = (job) => {
  const min = job?.salaryMin != null ? Number(job.salaryMin) : null;
  const max = job?.salaryMax != null ? Number(job.salaryMax) : null;

  if (min && max) return `${min.toLocaleString()} – ${max.toLocaleString()} ETB`;
  if (min) return `${min.toLocaleString()}+ ETB`;
  if (max) return `Up to ${max.toLocaleString()} ETB`;
  return "Competitive";
};

export const formatJobExperience = (job) => {
  const level = job?.experience || job?.experienceLevel;
  if (!level) return "Not specified";
  return level.charAt(0) + level.slice(1).toLowerCase().replace("_", " ");
};

export const formatJobType = (job) => {
  const type = job?.type || job?.workType;
  if (!type) return "Full-time";
  return type.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
};

export const formatJobText = (text) => {
  if (!text) return [];
  return text
    .split(/\n+/)
    .map((line) => line.trim())
    .filter(Boolean);
};

/** Plain-text preview for cards and notifications */
export const getJobDescriptionSnippet = (text, maxLength = 100) => {
  if (!text) return "";
  const cleaned = String(text)
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<\/p>/gi, " ")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\s+/g, " ")
    .trim();
  if (!cleaned) return "";
  if (cleaned.length <= maxLength) return cleaned;
  const truncated = cleaned.slice(0, maxLength);
  const lastSpace = truncated.lastIndexOf(" ");
  const slice = lastSpace > maxLength * 0.55 ? truncated.slice(0, lastSpace) : truncated;
  return `${slice}…`;
};

/** Card snippet — description first, then requirements */
export const getJobCardSnippet = (job, maxLength = 100) => {
  const source = job?.description || job?.requirements || "";
  return getJobDescriptionSnippet(source, maxLength);
};
